import { $, $$ } from '@3pc/dom';

async function initDatePicker(element) {
  const { default: flatpickr } = await import(
    /* webpackChunkName: 'flatpickr' */ 'flatpickr'
  );
  const { default: locale } = await import(
    /* webpackChunkName: 'flatpickrLocale' */ 'flatpickr/dist/l10n/de'
  );
  const lang = document.documentElement.lang.split('-')[0];
  flatpickr(element, {
    altInput: true,
    altFormat: 'd.m.Y',
    dateFormat: 'Y-m-d',
    locale: locale[lang],
  });
}

$$('.searchform [data-flatpickr]').forEach(initDatePicker);

// Indexed Search Pagination
const searchForm = $('form.searchform');
const pageInput = $('#tx_indexedsearch_pointer');
if (searchForm && pageInput) {
  $$('.pagination a[data-page]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      pageInput.value = parseInt(link.dataset.page) - 1;
      searchForm.submit();
    });
  });
}
